// ----------------------------------------------------------------------

const shape = {
  borderRadius: 10,
  borderRadiusSm: 14,
  borderRadiusMd: 20
};

export default shape;
